import { render, staticRenderFns } from "./CalendarSync.vue?vue&type=template&id=1dcfc560&"
import script from "./CalendarSync.vue?vue&type=script&lang=js&"
export * from "./CalendarSync.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSync.vue?vue&type=style&index=0&id=1dcfc560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports